import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';
import mapOutline from '@iconify/icons-eva/map-outline';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'Trasy',
    path: '/dashboard/trips',
    icon: getIcon(mapOutline)
  },
  {
    title: 'Treść strony',
    icon: getIcon(mapOutline),
    children: [
      {
        title: 'Nasza misja',
        path: '/dashboard/content/naszaMisja',
        icon: getIcon(peopleFill)
      }
    ]
  },
  {
    title: 'Media',
    path: '/dashboard/media',
    icon: getIcon(peopleFill)
  },
  {
    title: 'Galeria',
    path: '/dashboard/gallery',
    icon: getIcon(peopleFill)
  },
  {
    title: 'Regulamin',
    path: '/dashboard/statute',
    icon: getIcon(mapOutline)
  },
  {
    title: 'Polityka prywatności',
    path: '/dashboard/privacy',
    icon: getIcon(mapOutline)
  },
  {
    title: 'Użytkownicy',
    path: '/dashboard/users',
    icon: getIcon(peopleFill)
  }
];

export default sidebarConfig;
